import React from 'react';
import PropTypes from 'prop-types';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import imageMarkerArrupUpSmall from './images/marker-arrow-up-h19.svg';

const LOCALE_DEFAULT_DATE_STRING_FORMAT_OPTIONS = {
    month: 'short',
    day: 'numeric'
}

export default class DataWidgetDataBarMarkerLabel extends React.PureComponent {

    render() {
        const dateWithTimezome = this.props.dateString.endsWith('Z') ? this.props.dateString : this.props.dateString + 'Z';
        const date = new Date(dateWithTimezome);
        return (
            <div className="bar-marker-label" style={{ 'left' : this.props.percentageLeftOffset + '%' }}>
                <img src={imageMarkerArrupUpSmall} />
                <div>{this.props.label}</div>
                <div>{"(" + date.toLocaleDateString(getCurrentLocale(), LOCALE_DEFAULT_DATE_STRING_FORMAT_OPTIONS) + ")"}</div>
            </div>
        )
    }
}

DataWidgetDataBarMarkerLabel.propTypes = {
    label: PropTypes.string.isRequired,
    percentageLeftOffset: PropTypes.number.isRequired,
    dateString: PropTypes.string.isRequired
};
